export const TEST_IDS = {
  CONFIRMATION_MODAL: 'accept-inbound-carrier-option-confirmation-modal',
  CONFIRMATION_MODAL_SUBMIT: 'accept-inbound-carrier-option-submit',
  NON_COMPLIANT_ERROR: 'accept-inbound-carrier-non-compliant-error',
}
